export default "__VITE_ASSET__533c80f5__"